'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssignedResponderInWidget = undefined;

var _reselect = require('reselect');

var _findAssignedResponder = require('conversations-schema/thread/operators/findAssignedResponder');

var _getResponders = require('conversations-schema/operators/widget-data/getResponders');

var _getCurrentConversation = require('../../selectors/conversationSelectors/getCurrentConversation');

var _getWidgetData = require('../../selectors/widgetDataSelectors/getWidgetData');

var _getWidgetBotResponder = require('../../selectors/widgetDataSelectors/getWidgetBotResponder');

var getAssignedResponderInWidget = exports.getAssignedResponderInWidget = (0, _reselect.createSelector)([_getWidgetData.getWidgetData, _getCurrentConversation.getCurrentConversation, _getWidgetBotResponder.getWidgetBotResponder], function (widgetData, currentConversation, botResponder) {
  return (0, _findAssignedResponder.findAssignedResponder)({
    thread: currentConversation,
    responders: (0, _getResponders.getResponders)(widgetData),
    botResponder: botResponder
  });
});


//////////////////
// WEBPACK FOOTER
// ./js/responders/selectors/getAssignedResponderInWidget.js
// module id = 79
// module chunks = 2 3